module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "audio-player-container"
  }, [_c('img', {
    class: {
      disabledBtn: !_vm.audioFile
    },
    attrs: {
      "width": _vm.hideProgressBar ? '50px' : '25px',
      "height": _vm.hideProgressBar ? '50px' : '25px',
      "src": _vm.audio && _vm.audio.paused ?
        require('../../assets/svg/play2.svg').default :
        require('../../assets/svg/pause.svg').default
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (!_vm.hideProgressBar && _vm.audioFile) ? _c('button', {
    staticClass: "speed-btn",
    attrs: {
      "title": ("מהירות: " + _vm.playbackRate + "x")
    },
    on: {
      "click": _vm.cycleSpeed
    }
  }, [_vm._v("\n    " + _vm._s(_vm.playbackRate) + "x\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.hideProgressBar) ? _c('input', {
    ref: "progressBar",
    staticClass: "slider",
    attrs: {
      "type": "range",
      "name": "progressBar",
      "id": "progressBar"
    },
    domProps: {
      "value": _vm.progressBar
    },
    on: {
      "input": _vm.changeProgress
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72784649","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/AudioPlayer.vue
// module id = 239
// module chunks = 0 1 2 3 4 7 17